import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 * Description: This component wraps the <InterdictionModal> component provided by
 * wfui-digital-core. It provides logic for handling events generated by <FragmentEventWrapper>
*/
import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import { retryPromise } from 'wfui-digital-core/es/lib';
import ErrorBoundary from '../error-boundary/ErrorBoundary';
import SuspenseOverlay from '../suspense-overlay/SuspenseOverlay';
import navigateFromElement from '../../lib/navigation/navigate-from-element';
import { requestNavigation } from '../../lib/store/navigation/actions';
import { showModuleError } from '../../lib/store/module-error/actions';
var InterdictionModal = /*#__PURE__*/React.lazy(function () {
  return retryPromise(function () {
    return import(
    /* webpackChunkName: "Interdiction" */
    'wfui-digital-core/es/InterdictionModal');
  });
});

var DBDInterdictionModal = function DBDInterdictionModal(_ref) {
  var interdictionActive = _ref.interdictionActive,
      handleNavigation = _ref.handleNavigation,
      props = _objectWithoutProperties(_ref, ["interdictionActive", "handleNavigation"]);

  var handleContentClick = function handleContentClick(_ref2) {
    var target = _ref2.target,
        container = _ref2.container;

    if (!navigateFromElement({
      target: target,
      container: container,
      handleNavigation: handleNavigation
    })) {
      props.handleContentClick && props.handleContentClick({
        target: target,
        container: container
      });
    }
  };

  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    action: showModuleError
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(SuspenseOverlay, null)
  }, interdictionActive && /*#__PURE__*/React.createElement(InterdictionModal, {
    handleContentClick: handleContentClick
  })));
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var digitalCore = _ref3.digitalCore;
  return {
    interdictionActive: digitalCore.interdiction.active
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleNavigation: function handleNavigation(navigationItem) {
      return dispatch(requestNavigation(navigationItem.toJS()));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DBDInterdictionModal);